import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import CookieConsent from './components/CookieConsent';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ProcessPage from './pages/ProcessPage';
import PricingPage from './pages/PricingPage';
import ContactPage from './pages/ContactPage';
import PrivacyTermsPage from './pages/PrivacyTermsPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AtlantaSoftwareDevelopmentPage from './pages/AtlantaSoftwareDevelopmentPage';
import GeorgiaCloudConsultingPage from './pages/GeorgiaCloudConsultingPage';
import AdminLayout from './components/layout/AdminLayout';
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import LeadsPage from './pages/admin/LeadsPage';
import CalendarPage from './pages/admin/CalendarPage';
import BlogPage from './pages/admin/BlogPage';
import NewsletterPage from './pages/admin/NewsletterPage';
import ScriptsPage from './pages/admin/ScriptsPage';
import EmailTemplatesPage from './pages/admin/EmailTemplatesPage';
import './styles/globals.css';

function App() {
  function GoogleAnalytics() {
    const location = useLocation();
    useEffect(() => {
      if (window.gtag) {
        window.gtag('config', 'G-KK8P97GJHT', {
          page_path: location.pathname + location.search,
        });
      }
    }, [location.pathname, location.search]);
    return null;
  }

  return (
    <AuthProvider>
      <HelmetProvider>
        <Router>
          {/* Send page_view on route changes */}
          <GoogleAnalytics />
          {/* Cookie consent banner */}
          <CookieConsent />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Layout><HomePage /></Layout>} />
            <Route path="/services" element={<Layout><ServicesPage /></Layout>} />
            <Route path="/process" element={<Layout><ProcessPage /></Layout>} />
            <Route path="/pricing" element={<Layout><PricingPage /></Layout>} />
            <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
            <Route path="/privacy" element={<Layout><PrivacyTermsPage /></Layout>} />
            <Route path="/atlanta-software-development" element={<Layout><AtlantaSoftwareDevelopmentPage /></Layout>} />
            <Route path="/georgia-cloud-consulting" element={<Layout><GeorgiaCloudConsultingPage /></Layout>} />
            <Route path="/privacy-terms" element={<Navigate to="/privacy" replace />} />
            
            {/* Admin Login (Public) */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            
            {/* Admin Routes (Protected) */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<AdminDashboardPage />} />
              <Route path="leads" element={<LeadsPage />} />
              <Route path="calendar" element={<CalendarPage />} />
              <Route path="blog" element={<BlogPage />} />
              <Route path="newsletter" element={<NewsletterPage />} />
              <Route path="scripts" element={<ScriptsPage />} />
              <Route path="email-templates" element={<EmailTemplatesPage />} />
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </HelmetProvider>
    </AuthProvider>
  );
}

export default App;
